import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HeaderService {
  private showCreateAccountOptionsSource = new BehaviorSubject<boolean>(false);
  showCreateAccountOptions$ = this.showCreateAccountOptionsSource.asObservable();

  private showServiceButtonVisibleSource = new BehaviorSubject<boolean>(true);
  showServiceButtonVisible$ = this.showServiceButtonVisibleSource.asObservable();

  private serviceRequestModeSource = new BehaviorSubject<boolean>(false);
  serviceRequestMode$ = this.serviceRequestModeSource.asObservable();

  toggleCreateAccountOptions(show: boolean) {
    this.showCreateAccountOptionsSource.next(show);
  }

  toggleServiceButtonVisible(show: boolean) {
    this.showServiceButtonVisibleSource.next(show);
  }

  toggleServiceRequestMode(show: boolean) {
    this.serviceRequestModeSource.next(show);
  }
}
